<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("vehicles")}}</h4>
                <p class="text-subtitle-1">{{$t("list_of_vehicles")}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2">
            <v-col cols="12" md="3" v-if="hasPermission(permissions.vehicle.create)">
                <v-btn block color="primary" @click="$router.push({ name: 'VehicleCreate' })">
                    <v-icon left>mdi-plus</v-icon>
                    {{$t("new_vehicle")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            block 
                            depressed 
                            v-on="on"
                            v-bind="attrs">
                            <v-icon left>mdi-magnify</v-icon>
                            {{$t("search")}}
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>{{$t('search')}}</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        :label="$t('Plate_No')"
                                        v-model="form.plate_number"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        clearable
                                        @keypress.enter="searchAndFetchVehicleAsync"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        :label="$t('unit_number')"
                                        v-model="form.unit_number"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        clearable
                                        @keypress.enter="searchAndFetchVehicleAsync"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-row no-gutters>
                                <v-col>
                                    <v-btn block color="primary" @click="searchAndFetchVehicleAsync">
                                        {{$t('submit')}}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="items"
                    :server-items-length="serverItemsLength"
                    :page.sync="page"
                    :options.sync="options"
                    @dblclick:row="handleRowDblClick"
                    disable-sort
                    :loading="loading"
                    >
                    <!-- Plate -->
                    <template v-slot:[`item.plate`]="{item}">
                        <span v-if="item.plate">
                            <v-btn icon @click="handleRowClick(item)">
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                            {{item.plate.initials}} {{item.plate.number}}
                        </span>
                    </template>

                    <!-- Brand -->
                    <template v-slot:[`item.brand`]="{item}">
                        <span v-if="item.model && item.model.brand">
                            {{item.model.brand.name}}
                        </span>
                    </template>

                    <!-- Model -->
                    <template v-slot:[`item.model`]="{item}">
                        <span v-if="item.model">
                            {{item.model.name}}
                        </span>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import service from './../../services/fleet/vehicle'
import permissions from '../../data/permissions';
import authorize from '../../utils/authorize';
export default {
    data() {
        return {
            headers: [
                { text: this.$t("Plate_No"), value: "plate" },
                { text: this.$t("Unit_No"), value: "unit_number" },
                { text: this.$t("brand"), value: "brand" },
                { text: this.$t("Model"), value: "model" },
                { text: this.$t("Year"), value: "manufacture_year" },
            ],
            serverItemsLength: 0,
            page: 1,
            options: {},
            form: {
                plate: "",
                unit_number: ""
            },
            items: [],
            loading: false,
            permissions
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetchVehiclesAsync();
            }
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetchVehiclesAsync() {
            this.items = [];
            this.loading = true;
            service.list({...this.options, ...this.form}).then(response => {
                this.items = response.data.data;
                this.serverItemsLength = response.data.total;
            }).finally(() => {  
                this.loading = false;
            });
        },
        searchAndFetchVehicleAsync() {
            this.page = 1;
            this.fetchVehiclesAsync();
        },
        handleRowClick(row) {
            this.vehicleDisplay(row.id)
        },
        handleRowDblClick(e, {item}) {
            this.vehicleDisplay(item.id)
        },
        vehicleDisplay(vehicleID) {
            this.$router.push({
                name: "VehicleDisplay",
                params: {
                    vehicleID
                }
            })
        }
    }
}
</script>

<style>

</style>